export default "__VITE_ASSET__DkHDpWyk__"